import React, { useState, useEffect } from 'react'
import axios from 'axios'
import MyIcon from '../../../components/general/icon'
import MajorFilter from '../../../components/filter/majorFilter'
import AddMajor from './add'
import EditMajor from './edit'
import DeleteMajor from './delete'

export default function Major() {
  const merchantOid = localStorage.getItem('merchant_oid')
  const [majorList, setMajorList] = useState([])
  const [propsData, setPropsData] = useState({})
  const [isAddMajorVisible, setIsAddMajorVisible] = useState(false)
  const [isEditMajorVisible, setIsEditMajorVisible] = useState(false)
  const [isDeleteMajorVisible, setIsDeleteMajorVisible] = useState(false)

  const initialConditions = {
    college_oid: '',
    keywords: '',
    sort_filter: 0,
  }
  const [filterValue, setFilterValue] = useState(initialConditions)

  const getMajorList = () => {
    axios.post('/p/info/major/list/get', { 
      merchant_oid: merchantOid,
      college_oid: filterValue.college_oid,
      keywords: filterValue.keywords,
      sort_filter: filterValue.sort_filter,
    })
      .then(function (response) {
        if (response.errcode === 0) {
          setMajorList(response.data)
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  useEffect(() => {
    getMajorList()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [merchantOid, filterValue])

  const editMajor = (oid) => {
    setIsEditMajorVisible(true)
    setPropsData({ oid: oid })
  }

  const deleteMajor = (oid, name) => {
    setIsDeleteMajorVisible(true)
    setPropsData({ oid: oid, name: name})
  }

  return (
    <div className="public-page">
      <div className="public-container">
        <div className="public-header">
          <div className="public-title">招生专业</div>
          <MajorFilter filterValue={filterValue} setFilterValue={setFilterValue} isAddVisible={() => { setIsAddMajorVisible(true) }}  />
        </div>

        <div className='public-main-style'>
          <div className='public-main-style2'>
            <table className='public-main-style2-item'>
              <thead>
                <tr className='public-main-style2-thead'>
                  <th style={{textAlign: 'left', paddingLeft: '20px'}}>专业名称</th>
                  <th>所属院系</th>
                  <th>排序</th>
                  <th style={{width: '50px'}}></th>
                </tr>
              </thead>

              <tbody>
                {majorList && (majorList.length > 0 ? (majorList.map((item) => (
                  <tr className='public-main-style2-tbody' key={item.oid} onClick={() => { editMajor(item.oid) }}>
                    <td style={{textAlign: 'left', paddingLeft: '20px'}}>{item.name}</td>
                    <td>{item.college}</td>
                    <td>{item.sort}</td>
                    <td style={{width: '50px'}}>
                      <div className='public-main-style2-operation-box'>
                        <div className='public-main-style2-operation' 
                          onClick={(event) => {event.stopPropagation(); deleteMajor(item.oid, item.name)}}>
                          <MyIcon name='huishouzhan' />
                        </div>
                      </div>
                    </td>
                  </tr>
                ))) : (
                  <tr className='public-main-style2-tbodyEmpty'>
                    <td colSpan="4"><span>暂无数据</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {isAddMajorVisible && <AddMajor
        getMajorList={getMajorList} 
        isOpen={isAddMajorVisible} 
        isCancel={() => { setIsAddMajorVisible(false) }} 
      />}

      {isEditMajorVisible && <EditMajor
        data={propsData}
        getMajorList={getMajorList} 
        isOpen={isEditMajorVisible} 
        isCancel={() => { setIsEditMajorVisible(false) }} 
      />}

      {isDeleteMajorVisible && <DeleteMajor
        data={propsData}
        getMajorList={getMajorList} 
        isOpen={isDeleteMajorVisible} 
        isCancel={() => { setIsDeleteMajorVisible(false) }} 
      />}
    </div>
  )
}
